module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/qrcode_chowbus-7c4dbb5dd0ca6ceaa09036d3eba83bb3.jpg";